import React from 'react';
import { Colors } from '@common/tokens';
import { InputNumber } from 'antd';

export const PercentInput = (
  props: React.ComponentProps<typeof InputNumber>
) => (
  <>
    <div className="percent-input">
      <InputNumber {...props} min={0} />
    </div>
    <style jsx>{`
      .percent-input {
        position: relative;
      }

      .percent-input :global(.ant-input-number::before) {
        content: '%';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 8px;
        color: ${Colors.midnightLighter};
      }

      .percent-input :global(input) {
        padding-right: 25px;
      }

      .percent-input :global(.ant-input-number) {
        width: 100%;
      }

      .percent-input :global(.ant-input-number-handler-wrap) {
        display: none;
      }
    `}</style>
  </>
);
